import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

const EditPersonalInfoModal = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Personal Info</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>Passport No</Form.Label>
            <Form.Control />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Nationality</Form.Label>
            <Form.Control />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Religion</Form.Label>
            <Form.Control />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={onHide}>Save</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditPersonalInfoModal;